import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { Input } from '../ui/Input';
import { RadioGroup } from '../ui/RadioGroup';
import { MascotPanel } from '../ui/MascotPanel';
import { Button } from '../ui/Button';
import { PlusIcon, Trash2Icon } from 'lucide-react';
export function Step4Company() {
  const {
    data,
    updateData
  } = useIntake();
  const addLocation = () => {
    const newLocation = {
      id: Date.now().toString(),
      name: '',
      street: '',
      postcode: '',
      city: '',
      province: '',
      country: 'Nederland',
      phone: '',
      email: '',
      hours: '',
      showOnWebsite: 'yes',
      needsPage: false,
      services: ''
    };
    updateData({
      locations: [...data.locations, newLocation]
    });
  };
  const removeLocation = (id: string) => {
    updateData({
      locations: data.locations.filter(l => l.id !== id)
    });
  };
  const updateLocation = (id: string, field: string, value: any) => {
    updateData({
      locations: data.locations.map(l => l.id === id ? {
        ...l,
        [field]: value
      } : l)
    });
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-362">
      <MascotPanel message="Tijd voor de officiële gegevens. Deze informatie gebruiken we voor de contactpagina, footer en eventuele juridische documenten op uw nieuwe website." data-id="element-363" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8" data-id="element-364">
        <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-365">
          Bedrijfsgegevens
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-366">
          <Input label="Bedrijfsnaam (Statutair)" value={data.companyName} onChange={e => updateData({
          companyName: e.target.value
        })} data-id="element-367" />
          <Input label="Handelsnaam (indien anders)" value={data.tradeName} onChange={e => updateData({
          tradeName: e.target.value
        })} data-id="element-368" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-369">
          <Input label="KVK Nummer" value={data.cocNumber} onChange={e => updateData({
          cocNumber: e.target.value
        })} data-id="element-370" />
          <Input label="BTW Nummer" value={data.vatNumber} onChange={e => updateData({
          vatNumber: e.target.value
        })} data-id="element-371" />
        </div>

        <div className="mb-6" data-id="element-372">
          <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-373">
            Hoofdvestiging adres
          </h3>
          <p className="text-sm text-gray-500 mb-4" data-id="element-374">
            Vul uw straat en huisnummer in — de overige velden worden waar
            mogelijk automatisch aangevuld.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-375">
            <Input label="Straat + Huisnummer" placeholder="Bijv. Keizersgracht 123" value={data.mainStreet} onChange={e => updateData({
            mainStreet: e.target.value
          })} data-id="element-376" />
            <Input label="Postcode" placeholder="1234 AB" value={data.mainPostcode} onChange={e => updateData({
            mainPostcode: e.target.value
          })} data-id="element-377" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-378">
            <Input label="Stad" placeholder="Amsterdam" value={data.mainCity} onChange={e => updateData({
            mainCity: e.target.value
          })} data-id="element-379" />
            <Input label="Provincie" placeholder="Noord-Holland" value={data.mainProvince} onChange={e => updateData({
            mainProvince: e.target.value
          })} data-id="element-380" />
            <Input label="Land" value={data.mainCountry} onChange={e => updateData({
            mainCountry: e.target.value
          })} data-id="element-381" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-382">
          <Input label="Algemeen telefoonnummer" value={data.companyPhone} onChange={e => updateData({
          companyPhone: e.target.value
        })} data-id="element-383" />
          <Input label="Algemeen e-mailadres" type="email" value={data.companyEmail} onChange={e => updateData({
          companyEmail: e.target.value
        })} data-id="element-384" />
        </div>

        <div className="mb-8" data-id="element-385">
          <Input label="Huidige website URL (indien van toepassing)" placeholder="https://www.uwbedrijf.nl" value={data.existingWebsiteUrl} onChange={e => updateData({
          existingWebsiteUrl: e.target.value
        })} data-id="element-386" />
        </div>

        <div className="pt-8 border-t border-gray-100" data-id="element-387">
          <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-388">Locaties</h3>

          <div className="mb-6" data-id="element-389">
            <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-390">
              Heeft u meerdere locaties?
            </label>
            <RadioGroup columns={2} value={data.multipleLocations} onChange={val => updateData({
            multipleLocations: val
          })} options={[{
            value: 'yes',
            label: 'Ja, meerdere locaties'
          }, {
            value: 'no',
            label: 'Nee, één locatie'
          }]} data-id="element-391" />
          </div>

          <AnimatePresence data-id="element-392">
            {data.multipleLocations === 'yes' && <motion.div initial={{
            opacity: 0,
            height: 0
          }} animate={{
            opacity: 1,
            height: 'auto'
          }} exit={{
            opacity: 0,
            height: 0
          }} className="overflow-hidden space-y-6" data-id="element-393">
                <div data-id="element-394">
                  <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-395">
                    Hoe wilt u de locaties op de website verwerken?
                  </label>
                  <RadioGroup columns={1} value={data.locationStrategy} onChange={val => updateData({
                locationStrategy: val
              })} options={[{
                value: 'separate_website',
                label: 'Een aparte website per locatie'
              }, {
                value: 'separate_page',
                label: 'Een aparte pagina per locatie op dezelfde website'
              }, {
                value: 'mention_only',
                label: 'Eén website met alleen benoeming van de locaties (bijv. in de footer)'
              }, {
                value: 'no_mention',
                label: 'Geen benoeming van specifieke locaties'
              }, {
                value: 'specific_only',
                label: 'Alleen specifieke locaties benoemen, andere niet'
              }]} data-id="element-396" />
                </div>

                <div className="bg-blue-50 p-4 rounded-xl border border-blue-100" data-id="element-397">
                  <p className="text-sm text-blue-800" data-id="element-398">
                    <strong data-id="element-399">Tip voor gebruikersgemak:</strong> Voeg uw locaties
                    hieronder toe. Wij denken graag met u mee over een handige
                    zoekfunctie of interactieve kaart voor uw bezoekers.
                  </p>
                </div>

                <div className="space-y-6" data-id="element-400">
                  <h4 className="font-bold text-gray-900" data-id="element-401">
                    Locaties toevoegen
                  </h4>

                  {data.locations.map((loc, index) => <motion.div key={loc.id} initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} className="p-6 bg-gray-50 rounded-2xl border border-gray-200 relative space-y-4" data-id="element-402">
                      <button onClick={() => removeLocation(loc.id)} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors" data-id="element-403">
                        <Trash2Icon className="w-5 h-5" data-id="element-404" />
                      </button>

                      <h5 className="font-semibold text-gray-900" data-id="element-405">
                        Locatie {index + 1}
                      </h5>

                      <Input label="Naam locatie (bijv. Vestiging Amsterdam)" value={loc.name} onChange={e => updateLocation(loc.id, 'name', e.target.value)} data-id="element-406" />

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-407">
                        <Input label="Straat + Huisnummer" value={loc.street} onChange={e => updateLocation(loc.id, 'street', e.target.value)} data-id="element-408" />
                        <Input label="Postcode" value={loc.postcode} onChange={e => updateLocation(loc.id, 'postcode', e.target.value)} data-id="element-409" />
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-410">
                        <Input label="Stad" value={loc.city} onChange={e => updateLocation(loc.id, 'city', e.target.value)} data-id="element-411" />
                        <Input label="Provincie" value={loc.province} onChange={e => updateLocation(loc.id, 'province', e.target.value)} data-id="element-412" />
                        <Input label="Land" value={loc.country} onChange={e => updateLocation(loc.id, 'country', e.target.value)} data-id="element-413" />
                      </div>

                      {data.locationStrategy === 'specific_only' && <div className="pt-2" data-id="element-414">
                          <label className="block text-sm font-semibold text-gray-900 mb-2" data-id="element-415">
                            Deze locatie tonen op de website?
                          </label>
                          <RadioGroup columns={2} value={loc.showOnWebsite} onChange={val => updateLocation(loc.id, 'showOnWebsite', val)} options={[{
                    value: 'yes',
                    label: 'Ja, tonen'
                  }, {
                    value: 'no',
                    label: 'Nee, verbergen'
                  }]} data-id="element-416" />
                        </div>}
                    </motion.div>)}

                  <Button variant="outline" onClick={addLocation} className="w-full border-dashed" data-id="element-417">
                    <PlusIcon className="w-5 h-5 mr-2" data-id="element-418" />
                    Locatie toevoegen
                  </Button>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </motion.div>;
}